export enum ThemeType {
  Light = 'Light',
  Dark = 'Dark',
  Accent = 'Accent',
}
